import { Injectable } from '@angular/core';
import { BaseHttpService } from '../base/base-http.service';
import { HttpClient } from '@angular/common/http';
import { UserFavouritePageDto } from '../../models/base/base';
import { BaseService } from '../base/base.service';
import { TabSystemMenuService } from '../menu/tab-system-menu.service';
import { SessionWrapperService } from '../session/session-wrapper.service';

@Injectable({
  providedIn: 'root'
})
export class UserFavouritePageService extends BaseHttpService<UserFavouritePageDto> {
  //private currenSession = this.sessionWrapper.currentSessionValue;
  userid;
  constructor(
    private httpClinet: HttpClient,
    private sessionService: SessionWrapperService
  ) {
    super(httpClinet);
    let claims = JSON.parse(sessionStorage.getItem('id_token_claims_obj'));
    if (claims) {
      this.userid = claims['sub'];
    }
  }

  getResourceUrl(): string {
    return 'UserFavouritePages';
  }

  getUserFavouritePages() {
    if (!this.userid) return null;
    return this.getAllbyParam('GetFavouritePagesByUserId', { userid: this.userid });
  }

  getUserFavouritePagesWithMenu() {
    const syscode = this.sessionService.getSysCode();

    if (!this.userid) return null;
    return this.getAllbyParam('GetFavouritePagesDataByUserId', { userid: this.userid, syscode: syscode });
  }

  delete(id: string) {
    return this.httpClinet.post(`${this.baseUrl}/Delete?id=${id}`, {});
  }
}
